import { createSelector } from 'reselect';
import { invertedQueryMap } from '../../lib/constants/queryMap.js';

const locationSearch = (state) => state.router.location.search;

export const querySelector = (param) =>
  createSelector(locationSearch, (locationSearch) => {
    const queryMap = Object.fromEntries(
      String(locationSearch)
        .trim()
        .replace('?', '')
        .split('&')
        .map((n) => n.split('='))
        .map((n) => [invertedQueryMap[n[0]] || n[0], n[1]])
    );

    return param === undefined ? queryMap : queryMap[param];
  });

export default querySelector;
